import { useAppSelector } from '../../redux/hooks';
import EReg from '../e-reg/ereg';
import Pips from '../e-reg/Pips';
import ClientPortal from '../../Components/clientportal/App'
import Registrations from '../Registrations/Registration';
import React from 'react';
import SimilarNames from '../SimilarNames/similarName';
import { BuilderDoc } from '../BuilderDoc/BuilderDoc';

interface ReactFrameProps {
    reactFrame: string,
}


const ReactFrame = (props: ReactFrameProps) => {
    const livedataRoot: Element = useAppSelector((state) => state.currentNavigation.livedataRootContainer.dataRoot);
    if(livedataRoot !== null && livedataRoot !== undefined){
        switch (props.reactFrame.toLowerCase()) {
            case 'pips':
                return (<Pips/>);
            case 'ereg':
                return (<EReg/>);
            case 'registration': 
                return (<Registrations/>);
            case 'clientportal':
                return (<ClientPortal/>);
            case 'similiarnames': 
                return (<SimilarNames/>);
            case 'builderdoc':
                return (<BuilderDoc/>);
            default:
                return (<></>);
        }
    }
    return (<></>);
}

export default ReactFrame;